import { useTranslation } from 'react-i18next';
import { FunctionClassesTable } from '../../../../components/Classes/Tables/FunctionClassesTable';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const SetupFunctionClass = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canWriteSubstitution()}
      title={`${t('functionClass.title', { count: 2 })} ${t('common.setup').toLowerCase()}`}
    >
      <FunctionClassesTable />
    </Page>
  );
};
